import React, { useState, useEffect, useRef } from 'react'
import styles from '../../../styles/HomeLanding/IndiaLandingPage.module.css'
import { Button } from 'reactstrap'
import Image from 'next/image'
import { StyleRegistry } from 'styled-jsx'

const OutletsAndBusinesses = () => {
  const [activeIndex, setActiveIndex] = useState(1);  
  const contentMaskRef = useRef(null);
  const contentListRef = useRef(null);
  const activeIndexRef = useRef(activeIndex);

  useEffect(() => {
    let animationFrameId = 0;
    let initialScrollTimeoutId = 0;

    const handleScroll = () => {
      if (animationFrameId) return;

      animationFrameId = window.requestAnimationFrame(() => {
        animationFrameId = 0;
        if (!contentMaskRef.current || !contentListRef.current) return;

        const mask = contentMaskRef.current;
        const list = contentListRef.current;
        const items = list.getElementsByClassName(styles.content_item);
        
        const maskHeight = mask.clientHeight;
        const maskCenter = mask.scrollTop + maskHeight / 2;
      
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const itemTop = item.offsetTop;
          const itemHeight = item.clientHeight;
          const itemCenter = itemTop + itemHeight / 2;
          
          if (Math.abs(itemCenter - maskCenter) < itemHeight / 2) {
            if (activeIndexRef.current !== i) {
              activeIndexRef.current = i;
              setActiveIndex(i);
            }
            break;
          }
        }
      });
    };

    const mask = contentMaskRef.current;
    if (mask) {
      mask.addEventListener('scroll', handleScroll);
      handleScroll();
      
      initialScrollTimeoutId = window.setTimeout(() => {
        if (contentListRef.current) {
          const items = contentListRef.current.getElementsByClassName(styles.content_item);
          if (items[1]) {
            const itemHeight = items[1].clientHeight;
            const itemTop = items[1].offsetTop;
            const maskHeight = mask.clientHeight;
            mask.scrollTo({ top: itemTop - (maskHeight / 2) + (itemHeight / 2), behavior: 'smooth' });
          }
        }
      }, 100);
      
      return () => {
        mask.removeEventListener('scroll', handleScroll);
        window.cancelAnimationFrame(animationFrameId);
        window.clearTimeout(initialScrollTimeoutId);
      };
    }
  }, []);

  return (
    <>
      <div className={styles.outletsSection}  >
        {/* First container */}
        <div className={styles.titleContainer} >
          <div className={styles.numberContainer}>4 Mn+</div> <br />
          <div className={styles.textContainer}> Invoices Processed every Month. </div>
          <h3 className={styles.headline}>
          Diverse Industries, <br />One Trusted POS Solution
          </h3>
          <div className={styles.gradient_blue_outlet}></div>
          <div className={styles.btnContainer} style={{opacity:0}}> 
            <Button className={styles.fuature_white_arrow_QB_btn} style={{ cursor: "default" }}>
            View all outlets solutions
            </Button>
            <div className={styles.fuature_white_arrow_QB}>
              <div
                style={{
                  position: 'absolute',
                  width: '1.5rem',
                  height: '1.5rem',
                }}
              >
                <Image src="/assets/HomeLanding/arrow_white1.svg" fill  alt='Arrow Extend'/>
              </div>
            </div>
          </div>
        </div>

        {/* Second container */}
        <div style={{width: "50%", height: "100%"}}>
          <div className={styles.content}>
            <div className={styles.content_mask} ref={contentMaskRef}>
              <div className={styles.content_list} ref={contentListRef}>
                {['Retail', 'Restaurants', 'Electronics', 'Supermarkets', 'D2C Brands','Temples','Grocery',"Amusement Parks"].map((item, index) => (
                  <div 
                    key={index}
                    className={`${styles.content_item} ${index === activeIndex ? styles.active_item : ''}`}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OutletsAndBusinesses
